/* eslint-disable react/display-name */

/** TODO: refactor this so it has a display name */
import { Suspense, type ComponentType } from 'react';

import Loader from './Loader';

const Loadable =
  <P extends object>(Component: ComponentType<P>) =>
    
  (props: P) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
